import { createBrowserRouter, RouterProvider } from "react-router";
import PrivicyPolicy from "../../screens/PrivicyPolicy";
import Verification from "../../screens/Verification";
import ResetPassword from "../../screens/ResetPassword";

const router = createBrowserRouter([
    {
        path: '/',
        element: <PrivicyPolicy />
    },
    {
        path: '/verification/:id',
        element: <Verification />
    },
    {
        path: "/reset-password/:id",
        element: <ResetPassword />
    }
])

const AppRouting = () => {
    return (
        <RouterProvider router={router} />
    )
}

export default AppRouting